export default "__VITE_ASSET__C$56zlfB__"